import script from "./Comments.vue?vue&type=script&setup=true&lang=ts"
export * from "./Comments.vue?vue&type=script&setup=true&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=4dc7d5ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc7d5ae"]])

export default __exports__